// extracted by mini-css-extract-plugin
export var container = "_fg-1";
export var editor = "_fg-2";
export var resizable = "_fg-3";
export var wrapper = "_fg-0";